import { render, staticRenderFns } from "./CardRoundCtrl.vue?vue&type=template&id=67fe8cb0&"
import script from "./CardRoundCtrl.vue?vue&type=script&lang=ts&"
export * from "./CardRoundCtrl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports